import { GameListCopy } from "../copy/gameListCopy";

const Home = () => {
  return GameListCopy.map((item) => (
    <div
      key={item.id}
      className="flex m-10 mb-20 rounded-lg font-sans drop-shadow-lg"
    >
      <div className="flex-none w-96 col-span-2 mr-5 relative">
        <img
          src={item.imgUrl}
          alt={item.imgAlt}
          className="absolute inset-0 w-full h-full object-cover rounded-l-lg"
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <h3 className="pl-0">{item.name}</h3>
        <p className="pl-0 font-bold">Policy focus</p>
        <ul className="list-disc list-inside">
          {item.policyFocus.map((policy) => (
            <li key={policy}>{policy}</li>
          ))}
        </ul>
        <p className="pl-0 font-bold">Skills focus</p>
        <ul className="list-disc list-inside">
          {item.skillsFocus.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <p className="pl-0 max-w-2xl">{item.description}</p>
        {item.beta && (
          <div className="bg-red-200 mb-10 rounded-lg max-w-2xl">
            <h4 className="py-2 px-3 text-white text-sm bg-red-700 font-bold rounded-t-lg">
              Early access simulation
            </h4>
            <p className="px-3 py-2">
              This is a playable, fully functional simulation, but it’s not a
              polished final product. We still have some work to do, and we’d
              love to hear what you and your students think of this early
              version.
            </p>
          </div>
        )}
        <a
          href={item.gameLinkUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="py-3 px-5 bg-blue-500 text-white hover:bg-blue-200 hover:text-black rounded-md"
        >
          {item.gameLinkCopy}
        </a>
        <p className="pl-0 font-bold">Downloads</p>
        <div className="flex justify-apart xl:flex-row xl:space-y-0 flex-col space-y-5">
          {item.downloadLinks.map((link, index) => (
            <a
              key={index}
              href={link.linkUrl}
              target="_blank"
              rel="noreferrer noopener"
              className="py-3 px-5 bg-blue-500 text-white hover:bg-blue-200 hover:text-black rounded-md mr-3 w-48 text-center"
            >
              {link.linkCopy}
            </a>
          ))}
        </div>
      </div>
    </div>
  ));
};

export default Home;
